import { DownloadOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import getConfig from 'next/config';
import NextImage from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

/* eslint-disable-next-line */
export interface PdfExporterProps {
  children: React.ReactNode;
  isOpen: boolean;
  onFinish: () => void;
  onCancel: () => void;
  toPDF: () => void;
  targetRef: React.RefObject<HTMLDivElement>;
}

export function PdfExporter({
  children,
  isOpen,
  onCancel,
  onFinish,
  toPDF,
  targetRef,
}: PdfExporterProps) {
  const { t } = useTranslation('common');
  const { publicRuntimeConfig } = getConfig();

  return (
    <Modal
      closeIcon={null}
      open={isOpen}
      onCancel={onCancel}
      title={
        <div className="flex items-center justify-between">
          <div>{t('pdf_preview')}</div>
          <div className="flex flex-row space-x-2 items-center">
            <Button type="primary" shape="round" onClick={() => toPDF()}>
              <DownloadOutlined />
              {t('save_pdf')}
            </Button>
            <Button shape="round" onClick={onCancel}>
              {t('close')}
            </Button>
          </div>
        </div>
      }
      width={1106}
      footer={false}
    >
      <div className="mt-6 border border-gray-300 rounded-md">
        <div ref={targetRef} className="p-6" aria-readonly>
          <div className="space-y-4">
            <NextImage
              src={`${publicRuntimeConfig.staticFolder}/logo-full-transparent.svg`}
              height="48"
              width="200"
              priority
              alt={t('scv_logo')}
            />
            {children}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default PdfExporter;
